"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLETYPE = exports.CATEGORY_SECTION_TYPE = void 0;
var CATEGORY_SECTION_TYPE = {
  Section: 'section',
  Category: 'category'
};
exports.CATEGORY_SECTION_TYPE = CATEGORY_SECTION_TYPE;
var ROLETYPE = {
  primaryRole: 'primaryRole',
  customRole: 'customRole'
};
exports.ROLETYPE = ROLETYPE;